import { GameDocument } from '../../../types/game-document';
import { GetResourceValue } from '../resources';
/**
 * Get all timers from game document local storage.
 * @param gameDocument - The Game Document as datasource
 * @constructor
 */
export const GetTimers = (gameDocument: GameDocument | undefined) => {
  return gameDocument?.assets?.timers ?? [];
};

/**
 * Get Timers detail by ID from game document local storage.
 * @param gameDocument - The Game Document as datasource
 * @param timerId - The Game Document as datasource
 * @constructor
 */
export const GetTimerById = (
  gameDocument: GameDocument | undefined,
  timerId: string
) => {
  return (
    gameDocument?.assets?.timers?.filter((x) => timerId.indexOf(x.id) !== -1) ??
    []
  );
};

/**
 * Get Timer object detail by timerId
 * @param gameDocument - The Game Document as datasource
 * @param timerId - The Game Document as datasource
 * @returns
 */
export const GetTimerObjectById = (
  gameDocument: GameDocument,
  timerId: string
) => gameDocument.assets.timers?.find((x) => x.id === timerId);

/**
 * Get timer title by timer id from game document resources.
 * @param gameDocument - The Game Document as datasource
 * @param timerId - The timer id
 * @param languageId - The language ID
 */
export const GetTimerTitle = (
  gameDocument: GameDocument | undefined,
  timerId: string,
  languageId?: string
) => {
  if (!gameDocument || !timerId) return '';
  const timer = gameDocument?.assets?.timers?.find((x) => x.id === timerId);
  if (!timer || !timer.titleResId) return '';

  return GetResourceValue(gameDocument, timer.titleResId, languageId ?? '');
};

